
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("9f7qi"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("9f7qi", function(module, exports) {

let $6bab45dce923e94f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6bab45dce923e94f$var$load("5lTVp"),
    $6bab45dce923e94f$var$load("lWNY8"),
    $6bab45dce923e94f$var$load("1F7LX"),
    $6bab45dce923e94f$var$load("jZLnv"),
    $6bab45dce923e94f$var$load("6edij"),
    $6bab45dce923e94f$var$load("hXbzh"),
    $6bab45dce923e94f$var$load("gknbb"),
    $6bab45dce923e94f$var$load("6iz6l"),
    $6bab45dce923e94f$var$load("4SCW2"),
    $6bab45dce923e94f$var$load("36QeB"),
    $6bab45dce923e94f$var$load("kQSfw"),
    $6bab45dce923e94f$var$load("8PzH3"),
    $6bab45dce923e94f$var$load("2jJ1i"),
    $6bab45dce923e94f$var$load("bd77Q"),
    $6bab45dce923e94f$var$load("hnGEQ"),
    $6bab45dce923e94f$var$load("dek7I"),
    $6bab45dce923e94f$var$load("6SWFK"),
    $6bab45dce923e94f$var$load("9aQIt"),
    $6bab45dce923e94f$var$load("5zapo"),
    $6bab45dce923e94f$var$load("3MYQs"),
    $6bab45dce923e94f$var$load("XZauT"),
    $6bab45dce923e94f$var$load("4S1SF"),
    $6bab45dce923e94f$var$load("jiFtb"),
    $6bab45dce923e94f$var$load("lm9Lt"),
    $6bab45dce923e94f$var$load("9atVd"),
    $6bab45dce923e94f$var$load("9wPDc"),
    $6bab45dce923e94f$var$load("1MWOL"),
    $6bab45dce923e94f$var$load("6fQco"),
    $6bab45dce923e94f$var$load("dYtBN"),
    $6bab45dce923e94f$var$load("kNV5Y"),
    $6bab45dce923e94f$var$load("aOY32"),
    $6bab45dce923e94f$var$load("7jSfd"),
    $6bab45dce923e94f$var$load("4HZlX"),
    $6bab45dce923e94f$var$load("6wr18"),
    $6bab45dce923e94f$var$load("kDqHr"),
    $6bab45dce923e94f$var$load("jPuvo"),
    $6bab45dce923e94f$var$load("3GuOt"),
    $6bab45dce923e94f$var$load("7EorR"),
    $6bab45dce923e94f$var$load("ffEVr"),
    $6bab45dce923e94f$var$load("7j0mT"),
    $6bab45dce923e94f$var$load("69R9L"),
    $6bab45dce923e94f$var$load("kuFG2"),
    $6bab45dce923e94f$var$load("Wowvf"),
    $6bab45dce923e94f$var$load("hhss7"),
    $6bab45dce923e94f$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("2EtBv"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("2EtBv", function(module, exports) {

let $1ee647edf5ffa18c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1ee647edf5ffa18c$var$load("6wr18"),
    $1ee647edf5ffa18c$var$load("ffEVr"),
    $1ee647edf5ffa18c$var$load("a0cZb"),
    $1ee647edf5ffa18c$var$load("RXMWr"),
    $1ee647edf5ffa18c$var$load("7j0mT"),
    $1ee647edf5ffa18c$var$load("69R9L"),
    $1ee647edf5ffa18c$var$load("kuFG2"),
    $1ee647edf5ffa18c$var$load("1F7LX"),
    $1ee647edf5ffa18c$var$load("hXbzh"),
    $1ee647edf5ffa18c$var$load("hhss7"),
    $1ee647edf5ffa18c$var$load("h3ABO"),
    $1ee647edf5ffa18c$var$load("kC80R"),
    $1ee647edf5ffa18c$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("htUeM"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("htUeM", function(module, exports) {

let $cba0c4a7b35c788c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cba0c4a7b35c788c$var$load("41wXF"),
    $cba0c4a7b35c788c$var$load("f0c8J"),
    $cba0c4a7b35c788c$var$load("cyGuT"),
    $cba0c4a7b35c788c$var$load("b9CA3"),
    $cba0c4a7b35c788c$var$load("2YffH"),
    $cba0c4a7b35c788c$var$load("ijNBa"),
    $cba0c4a7b35c788c$var$load("hGJ7X"),
    $cba0c4a7b35c788c$var$load("kkxT0"),
    $cba0c4a7b35c788c$var$load("xu7ej"),
    $cba0c4a7b35c788c$var$load("iQ4FP"),
    $cba0c4a7b35c788c$var$load("3EXzu"),
    $cba0c4a7b35c788c$var$load("blwYk"),
    $cba0c4a7b35c788c$var$load("czd3n"),
    $cba0c4a7b35c788c$var$load("c6VA1"),
    $cba0c4a7b35c788c$var$load("2MTmD"),
    $cba0c4a7b35c788c$var$load("2wRqX"),
    $cba0c4a7b35c788c$var$load("50D4z"),
    $cba0c4a7b35c788c$var$load("j9Q0e"),
    $cba0c4a7b35c788c$var$load("71gca"),
    $cba0c4a7b35c788c$var$load("jlCbV"),
    $cba0c4a7b35c788c$var$load("5P3qs"),
    $cba0c4a7b35c788c$var$load("4oXMS"),
    $cba0c4a7b35c788c$var$load("gnDXu"),
    $cba0c4a7b35c788c$var$load("eQ8lL"),
    $cba0c4a7b35c788c$var$load("6O2my"),
    $cba0c4a7b35c788c$var$load("2B2rM"),
    $cba0c4a7b35c788c$var$load("b11Cj"),
    $cba0c4a7b35c788c$var$load("7bkye"),
    $cba0c4a7b35c788c$var$load("9anPW"),
    $cba0c4a7b35c788c$var$load("fAtWn"),
    $cba0c4a7b35c788c$var$load("iPYAE"),
    $cba0c4a7b35c788c$var$load("6iz6l"),
    $cba0c4a7b35c788c$var$load("4SCW2"),
    $cba0c4a7b35c788c$var$load("kQSfw"),
    $cba0c4a7b35c788c$var$load("8PzH3"),
    $cba0c4a7b35c788c$var$load("2jJ1i"),
    $cba0c4a7b35c788c$var$load("bd77Q"),
    $cba0c4a7b35c788c$var$load("5lTVp"),
    $cba0c4a7b35c788c$var$load("lWNY8"),
    $cba0c4a7b35c788c$var$load("8EEwj"),
    $cba0c4a7b35c788c$var$load("b2FtX"),
    $cba0c4a7b35c788c$var$load("c0JsV"),
    $cba0c4a7b35c788c$var$load("h3ABO"),
    $cba0c4a7b35c788c$var$load("coUzl"),
    $cba0c4a7b35c788c$var$load("5nMTY"),
    $cba0c4a7b35c788c$var$load("7j0mT"),
    $cba0c4a7b35c788c$var$load("69R9L"),
    $cba0c4a7b35c788c$var$load("6wr18"),
    $cba0c4a7b35c788c$var$load("f3xBO"),
    $cba0c4a7b35c788c$var$load("2wyaQ"),
    $cba0c4a7b35c788c$var$load("Wowvf"),
    $cba0c4a7b35c788c$var$load("9DBoM"),
    $cba0c4a7b35c788c$var$load("ffEVr"),
    $cba0c4a7b35c788c$var$load("hhss7"),
    $cba0c4a7b35c788c$var$load("a0cZb"),
    $cba0c4a7b35c788c$var$load("RXMWr"),
    $cba0c4a7b35c788c$var$load("1F7LX"),
    $cba0c4a7b35c788c$var$load("hXbzh"),
    $cba0c4a7b35c788c$var$load("jnVKv"),
    $cba0c4a7b35c788c$var$load("7EorR"),
    $cba0c4a7b35c788c$var$load("bgHzk"),
    $cba0c4a7b35c788c$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.b72ab509.js.map
